<!-- todo 仅用于数字控件 0 返回空 &千分位格式化，目前仅用于显示 临时使用 （财务审核 基本页签查看）-->
<template>
  <div class="numeric-stepper">
    <el-input
      v-model="ns"
      :disabled="nsDisabled"
      type="number"
      @change="onChange"
    />
    <el-checkbox v-if="showTact" v-model="tact" :disabled="tactDisabled" label="TACT" style="margin-left: 10px;" />
    <el-checkbox v-model="nil" :label="nilLabel" :disabled="nilDisabled" style="margin-left: 10px;" />
  </div>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { roundDecimalNum } from '@/utils'

export default {
  name: 'NumericStepper',
  props: {
    precision: { type: Number, default: 2 }, // 默认截取小数位数 2
    position: { type: String, default: '' },
    showTact: { type: Boolean, default: false },
    showValue: { type: Number, default: 0 },
    nilLabel: { type: String, default: 'NIL' }
  },
  data() {
    return {
      ns: '',
      nil: false,
      tact: false,
      nsDisabled: false,
      nilDisabled: false,
      tactDisabled: false
    }
  },
  computed: {
  },
  watch: {
    nil: function(newVal) {
      this.ns = null
      if (newVal) {
        this.$emit('onChangeValue', PriceConstant.NIL)
        this.nsDisabled = true
        this.tact = false
        this.tactDisabled = true
      } else {
        this.$emit('onChangeValue', 0)
        this.nsDisabled = false
        this.tactDisabled = false
      }
    },
    tact: function(newVal) {
      this.ns = null
      if (newVal) {
        this.$emit('onChangeValue', PriceConstant.TACT)
        this.nsDisabled = true
        this.nil = false
        this.nilDisabled = true
      } else {
        this.$emit('onChangeValue', 0)
        this.nsDisabled = false
        this.nilDisabled = false
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.showValue === PriceConstant.NIL) {
        this.nsDisabled = true
        this.nil = true
      }
      if (this.showValue === PriceConstant.TACT) {
        this.nsDisabled = true
        this.tact = true
      }
      this.ns = (!this.showValue || this.showValue === PriceConstant.NIL) ? null : roundDecimalNum(this.showValue, this.precision)
    },
    onChange(val) {
      let formatter = '0.'
      for (let i = 0; i < this.precision; i++) {
        formatter += '0'
      }
      const newVal = val === null ? 0 : this.$numeral(val).format(formatter)
      this.$emit('onChangeValue', Number(newVal))
      this.ns = (!newVal) ? null : newVal
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/styles/element-variables.scss";
  .numeric-stepper{
    display: flex;
    .el-input {
      width: 100%;
      margin-right: 4px;
      text-align:right;
    }
  }
</style>
